import React, { useEffect, useState, useCallback, useMemo } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

// LANCAMENTOS MANUAIS: a empresa recebe o comprovante do motorista (WhatsApp, por exemplo) e lanca aqui, escolhendo o VEICULO e o MOTORISTA
// dono do gasto. Quem lanca NAO aprova: o lancamento entra na fila de revisao do gestor (igual ao que vem do app).
const CATEGORIAS: Record<string, { rotulo: string; icone: string }> = {
  pedagio: { rotulo: "Pedágio", icone: "🛣️" }, alimentacao: { rotulo: "Alimentação", icone: "🍽️" }, hospedagem: { rotulo: "Hospedagem", icone: "🛏️" },
  estacionamento: { rotulo: "Estacionamento", icone: "🅿️" }, manutencao: { rotulo: "Manutenção", icone: "🔧" }, diaria: { rotulo: "Diária", icone: "💵" }, outros: { rotulo: "Outros", icone: "📎" },
}
const STATUS: Record<string, { cor: string; rotulo: string }> = {
  pendente_revisao: { cor: "#fbbf24", rotulo: "⏳ Aguardando revisão" }, anomalia: { cor: "#f87171", rotulo: "⚠️ Anomalia (gestor vai conferir)" },
  aprovado: { cor: "#4ade80", rotulo: "✅ Aprovado" }, rejeitado: { cor: "#94a3b8", rotulo: "🚫 Rejeitado" },
  pendente: { cor: "#fbbf24", rotulo: "⏳ Aguardando aprovação" }, aprovada: { cor: "#4ade80", rotulo: "✅ Aprovada" }, rejeitada: { cor: "#94a3b8", rotulo: "🚫 Rejeitada" },
}
const fmtData = (d: any) => (typeof d === "string" && /^\d{4}-\d{2}-\d{2}/.test(d) ? d.slice(8, 10) + "/" + d.slice(5, 7) + "/" + d.slice(0, 4) : "—")
const fmtDinheiro = (v: any) => (v == null || v === "" ? "—" : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }))
const numero = (v: string) => { const n = Number(String(v).trim().replace(",", ".")); return String(v).trim() === "" || !Number.isFinite(n) ? null : n }
const erroDe = (e: any, padrao: string) => e?.response?.data?.erro || padrao
const novaChave = () => (typeof crypto !== "undefined" && (crypto as any).randomUUID ? (crypto as any).randomUUID() : "xxxxxxxx-xxxx-4xxx-8xxx-xxxxxxxxxxxx".replace(/x/g, () => Math.floor(Math.random() * 16).toString(16)))

const caixa: React.CSSProperties = { background: "#0d1b2e", border: "1px solid #2d4166", borderRadius: 8, padding: 14 }
const rotulo: React.CSSProperties = { display: "block", fontSize: 12, color: "#94a3b8", marginBottom: 4 }

export default function LancamentosManuais() {
  const [aba, setAba] = useState<"abastecimento" | "despesa" | "meus">("abastecimento")
  const [op, setOp] = useState<any>(null)
  const [erroCarga, setErroCarga] = useState<string | null>(null)
  const [veiculoId, setVeiculoId] = useState("")
  const [motoristaId, setMotoristaId] = useState("")
  const [versao, setVersao] = useState(0)

  const carregar = useCallback(() => {
    axios.get(`${API}/lancamentos/opcoes`).then((r) => { setOp(r.data); setErroCarga(null) }).catch((e) => setErroCarga(erroDe(e, "Não foi possível carregar os veículos e motoristas.")))
  }, [])
  useEffect(() => { carregar() }, [carregar])

  const novaViagem = (v: any) => setOp((o: any) => ({ ...o, viagens_abertas: [v, ...(o?.viagens_abertas || [])] }))
  const aoLancar = () => setVersao((x) => x + 1)

  if (erroCarga) return <div className="page-content" style={{ padding: 24 }}><div role="alert" style={{ color: "#f87171" }}>{erroCarga}</div></div>
  if (!op) return <div className="page-content" style={{ padding: 24, color: "#64748b" }}>Carregando...</div>

  const seletores = (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
      <div><label style={rotulo}>Veículo *</label>
        <select aria-label="Veículo" value={veiculoId} onChange={(e) => setVeiculoId(e.target.value)} style={{ width: "100%" }}>
          <option value="">— Escolha o veículo —</option>
          {op.veiculos.map((v: any) => <option key={v.id} value={v.id}>{v.nome}{v.placa ? ` — ${v.placa}` : ""}</option>)}
        </select></div>
      <div><label style={rotulo}>Motorista (dono do gasto) *</label>
        <select aria-label="Motorista" value={motoristaId} onChange={(e) => setMotoristaId(e.target.value)} style={{ width: "100%" }}>
          <option value="">— Escolha o motorista —</option>
          {op.motoristas.map((m: any) => <option key={m.id} value={m.id}>{m.nome}</option>)}
        </select></div>
    </div>
  )
  const abaBtn = (id: "abastecimento" | "despesa" | "meus", texto: string) => (
    <button key={id} className={aba === id ? "btn btn-primary" : "btn btn-ghost"} onClick={() => setAba(id)} aria-pressed={aba === id}>{texto}</button>
  )

  return (
    <div className="page-content" style={{ padding: 24, maxWidth: 900 }}>
      <h2 style={{ marginBottom: 4 }}>🧾 Lançamentos manuais</h2>
      <div style={{ fontSize: 12, color: "#64748b", marginBottom: 14 }}>Lance aqui o comprovante que o motorista enviou. Você lança; quem aprova é o gestor.</div>
      <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap" }}>
        {abaBtn("abastecimento", "⛽ Abastecimento")}{abaBtn("despesa", "🧳 Despesa de viagem")}{abaBtn("meus", "📋 Meus lançamentos")}
      </div>
      {aba !== "meus" && seletores}
      {aba === "abastecimento" && <FormAbastecimento op={op} veiculoId={veiculoId} motoristaId={motoristaId} aoLancar={aoLancar} />}
      {aba === "despesa" && <FormDespesa op={op} veiculoId={veiculoId} motoristaId={motoristaId} novaViagem={novaViagem} aoLancar={aoLancar} />}
      {aba === "meus" && <MeusLancamentos versao={versao} />}
    </div>
  )
}

// ---------------------------------------------------------------- abastecimento
function FormAbastecimento({ op, veiculoId, motoristaId, aoLancar }: { op: any; veiculoId: string; motoristaId: string; aoLancar: () => void }) {
  const [km, setKm] = useState(""); const [litros, setLitros] = useState(""); const [valor, setValor] = useState("")
  const [data, setData] = useState<string>(op.hoje || ""); const [posto, setPosto] = useState(""); const [combustivel, setCombustivel] = useState("")
  const [recibo, setRecibo] = useState<File | null>(null); const [odometro, setOdometro] = useState<File | null>(null)
  const [duplicado, setDuplicado] = useState(false); const [permitir, setPermitir] = useState(false)
  const [erro, setErro] = useState<string | null>(null); const [ok, setOk] = useState<string | null>(null); const [enviando, setEnviando] = useState(false)
  const [chaveArquivos, setChaveArquivos] = useState(0)

  const enviar = async () => {
    setErro(null); setOk(null)
    if (!veiculoId) return setErro("Escolha o veículo.")
    if (!motoristaId) return setErro("Escolha o motorista dono do abastecimento.")
    const k = numero(km); if (k === null || k < 0) return setErro("Informe o KM do veículo.")
    const l = numero(litros); if (l === null || l <= 0) return setErro("Informe os litros (maior que zero).")
    const v = numero(valor); if (v === null || v <= 0) return setErro("Informe o valor total (maior que zero).")
    if (!data) return setErro("Informe a data do cupom.")
    if (op.hoje && data > op.hoje) return setErro("A data do cupom está no futuro.")
    if (!recibo) return setErro("Anexe a foto do comprovante do abastecimento.")
    const fd = new FormData()
    fd.append("ativo_id", veiculoId); fd.append("motorista_id", motoristaId); fd.append("km_informado", km); fd.append("litros", litros); fd.append("valor_total", valor)
    fd.append("data_recibo", data); if (posto.trim()) fd.append("posto_nome", posto.trim()); if (combustivel) fd.append("combustivel_tipo", combustivel)
    if (permitir) fd.append("permitir_duplicado", "1")
    fd.append("recibo", recibo); if (odometro) fd.append("odometro", odometro)
    setEnviando(true)
    try {
      const r = await axios.post(`${API}/lancamentos/abastecimentos`, fd)
      setOk(r.data?.status === "anomalia" ? `Lançado, mas ficou marcado como anomalia: ${r.data.motivo_anomalia || "o gestor vai conferir"}.` : "Abastecimento lançado. Agora aguarda a revisão do gestor.")
      setKm(""); setLitros(""); setValor(""); setPosto(""); setRecibo(null); setOdometro(null); setPermitir(false); setDuplicado(false); setChaveArquivos((x) => x + 1); aoLancar()
    } catch (e: any) {
      setErro(erroDe(e, "Não foi possível lançar o abastecimento."))
      if (e?.response?.status === 409) setDuplicado(true)
    } finally { setEnviando(false) }
  }

  return (
    <div style={caixa}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
        <div><label style={rotulo}>KM do veículo *</label><input aria-label="KM" inputMode="decimal" value={km} onChange={(e) => setKm(e.target.value)} placeholder="Ex.: 152300" style={{ width: "100%" }} /></div>
        <div><label style={rotulo}>Litros *</label><input aria-label="Litros" inputMode="decimal" value={litros} onChange={(e) => setLitros(e.target.value)} placeholder="Ex.: 40,5" style={{ width: "100%" }} /></div>
        <div><label style={rotulo}>Valor total (R$) *</label><input aria-label="Valor total" inputMode="decimal" value={valor} onChange={(e) => setValor(e.target.value)} placeholder="Ex.: 250,30" style={{ width: "100%" }} /></div>
        <div><label style={rotulo}>Data do cupom *</label><input aria-label="Data do cupom" type="date" value={data} max={op.hoje || undefined} onChange={(e) => setData(e.target.value)} style={{ width: "100%" }} /></div>
        <div><label style={rotulo}>Posto</label><input aria-label="Posto" value={posto} onChange={(e) => setPosto(e.target.value)} style={{ width: "100%" }} /></div>
        <div><label style={rotulo}>Combustível</label>
          <select aria-label="Combustível" value={combustivel} onChange={(e) => setCombustivel(e.target.value)} style={{ width: "100%" }}>
            <option value="">— Não informar —</option>{(op.combustiveis || []).map((c: string) => <option key={c} value={c}>{c}</option>)}
          </select></div>
        <div><label style={rotulo}>Foto do comprovante *</label><input key={"r" + chaveArquivos} aria-label="Foto do comprovante" type="file" accept="image/*" onChange={(e) => setRecibo(e.target.files?.[0] || null)} /></div>
        <div><label style={rotulo}>Foto do odômetro (opcional)</label><input key={"o" + chaveArquivos} aria-label="Foto do odômetro" type="file" accept="image/*" onChange={(e) => setOdometro(e.target.files?.[0] || null)} /></div>
      </div>
      {duplicado && (
        <label style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 12, fontSize: 13, color: "#fbbf24" }}>
          <input type="checkbox" aria-label="Lançar mesmo assim" checked={permitir} onChange={(e) => setPermitir(e.target.checked)} /> Lançar mesmo assim (é outro cupom)
        </label>
      )}
      {erro && <div role="alert" style={{ color: "#f87171", fontSize: 13, marginTop: 12 }}>{erro}</div>}
      {ok && <div role="status" style={{ color: "#4ade80", fontSize: 13, marginTop: 12 }}>✅ {ok}</div>}
      <div style={{ marginTop: 14 }}><button className="btn btn-primary" disabled={enviando} onClick={enviar}>{enviando ? "Lançando..." : "Lançar abastecimento"}</button></div>
    </div>
  )
}

// ---------------------------------------------------------------- despesa de viagem
function FormDespesa({ op, veiculoId, motoristaId, novaViagem, aoLancar }: { op: any; veiculoId: string; motoristaId: string; novaViagem: (v: any) => void; aoLancar: () => void }) {
  const [viagemId, setViagemId] = useState(""); const [categoria, setCategoria] = useState("pedagio"); const [valor, setValor] = useState("")
  const [data, setData] = useState<string>(op.hoje || ""); const [descricao, setDescricao] = useState(""); const [comprovante, setComprovante] = useState<File | null>(null)
  const [erro, setErro] = useState<string | null>(null); const [ok, setOk] = useState<string | null>(null); const [enviando, setEnviando] = useState(false)
  const [criando, setCriando] = useState(false); const [tituloViagem, setTituloViagem] = useState(""); const [chaveArquivos, setChaveArquivos] = useState(0)
  const [chave, setChave] = useState(novaChave())

  const viagens = useMemo(() => (op.viagens_abertas || []).filter((v: any) => v.ativo_id === veiculoId && (!v.motorista_id || v.motorista_id === motoristaId)), [op, veiculoId, motoristaId])
  useEffect(() => { if (viagemId && !viagens.find((v: any) => v.id === viagemId)) setViagemId("") }, [viagens, viagemId])

  const criarViagem = async () => {
    setErro(null)
    if (!veiculoId || !motoristaId) return setErro("Escolha o veículo e o motorista antes de criar a viagem.")
    try {
      const r = await axios.post(`${API}/lancamentos/viagens`, { ativo_id: veiculoId, motorista_id: motoristaId, titulo: tituloViagem })
      novaViagem(r.data); setViagemId(r.data.id); setCriando(false); setTituloViagem("")
    } catch (e: any) { setErro(erroDe(e, "Não foi possível criar a viagem.")) }
  }

  const enviar = async () => {
    setErro(null); setOk(null)
    if (!veiculoId) return setErro("Escolha o veículo.")
    if (!motoristaId) return setErro("Escolha o motorista dono da despesa.")
    if (!viagemId) return setErro("Escolha a viagem (ou crie uma viagem rápida).")
    const v = numero(valor); if (v === null || v <= 0) return setErro("Informe o valor da despesa (maior que zero).")
    if (!data) return setErro("Informe a data da despesa.")
    if (op.hoje && data > op.hoje) return setErro("A data da despesa está no futuro.")
    if (!comprovante && categoria !== "diaria") return setErro("Anexe a foto do comprovante (só a diária dispensa).")
    const fd = new FormData()
    fd.append("categoria", categoria); fd.append("valor", valor); fd.append("data_despesa", data); if (descricao.trim()) fd.append("descricao", descricao.trim()); fd.append("chave_cliente", chave)
    if (comprovante) fd.append("comprovante", comprovante)
    setEnviando(true)
    try {
      const r = await axios.post(`${API}/viagens/${viagemId}/despesas`, fd)
      setOk(r.data?.duplicada ? "Esta despesa já tinha sido lançada (não duplicou)." : "Despesa lançada. Agora aguarda a aprovação do gestor." + (r.data?.atencao ? ` Atenção: ${r.data.atencao}` : ""))
      setValor(""); setDescricao(""); setComprovante(null); setChaveArquivos((x) => x + 1); setChave(novaChave()); aoLancar()
    } catch (e: any) { setErro(erroDe(e, "Não foi possível lançar a despesa.")) }
    finally { setEnviando(false) }
  }

  return (
    <div style={caixa}>
      <div style={{ marginBottom: 12 }}>
        <label style={rotulo}>Viagem *</label>
        <div style={{ display: "flex", gap: 8 }}>
          <select aria-label="Viagem" value={viagemId} onChange={(e) => setViagemId(e.target.value)} style={{ flex: 1 }} disabled={!veiculoId}>
            <option value="">{!veiculoId ? "— Escolha o veículo primeiro —" : viagens.length ? "— Escolha a viagem —" : "— Nenhuma viagem aberta para este veículo —"}</option>
            {viagens.map((v: any) => <option key={v.id} value={v.id}>{v.titulo} ({fmtData(v.data_inicio)})</option>)}
          </select>
          <button className="btn btn-ghost" type="button" onClick={() => setCriando((c) => !c)}>➕ Viagem rápida</button>
        </div>
        {criando && (
          <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
            <input aria-label="Título da viagem" value={tituloViagem} onChange={(e) => setTituloViagem(e.target.value)} placeholder="Ex.: Entrega Marabá" style={{ flex: 1 }} />
            <button className="btn btn-primary" type="button" onClick={criarViagem}>Criar</button>
          </div>
        )}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
        <div><label style={rotulo}>Categoria *</label>
          <select aria-label="Categoria" value={categoria} onChange={(e) => setCategoria(e.target.value)} style={{ width: "100%" }}>
            {Object.entries(CATEGORIAS).map(([id, c]) => <option key={id} value={id}>{c.icone} {c.rotulo}</option>)}
          </select></div>
        <div><label style={rotulo}>Valor (R$) *</label><input aria-label="Valor" inputMode="decimal" value={valor} onChange={(e) => setValor(e.target.value)} placeholder="Ex.: 35,50" style={{ width: "100%" }} /></div>
        <div><label style={rotulo}>Data *</label><input aria-label="Data da despesa" type="date" value={data} max={op.hoje || undefined} onChange={(e) => setData(e.target.value)} style={{ width: "100%" }} /></div>
        <div style={{ gridColumn: "1 / span 2" }}><label style={rotulo}>Descrição</label><input aria-label="Descrição" value={descricao} onChange={(e) => setDescricao(e.target.value)} style={{ width: "100%" }} /></div>
        <div><label style={rotulo}>Foto do comprovante {categoria === "diaria" ? "(opcional)" : "*"}</label><input key={chaveArquivos} aria-label="Comprovante" type="file" accept="image/*" onChange={(e) => setComprovante(e.target.files?.[0] || null)} /></div>
      </div>
      {erro && <div role="alert" style={{ color: "#f87171", fontSize: 13, marginTop: 12 }}>{erro}</div>}
      {ok && <div role="status" style={{ color: "#4ade80", fontSize: 13, marginTop: 12 }}>✅ {ok}</div>}
      <div style={{ marginTop: 14 }}><button className="btn btn-primary" disabled={enviando} onClick={enviar}>{enviando ? "Lançando..." : "Lançar despesa"}</button></div>
    </div>
  )
}

// ---------------------------------------------------------------- meus lancamentos (so os que esta pessoa lancou)
function MeusLancamentos({ versao }: { versao: number }) {
  const [abast, setAbast] = useState<any[] | null>(null); const [desp, setDesp] = useState<any[] | null>(null); const [erro, setErro] = useState<string | null>(null)
  const carregar = useCallback(() => {
    axios.get(`${API}/lancamentos/abastecimentos`).then((r) => setAbast(r.data)).catch((e) => setErro(erroDe(e, "Não foi possível carregar seus abastecimentos.")))
    axios.get(`${API}/despesas-viagem`, { params: { limite: 100 } }).then((r) => setDesp(r.data)).catch((e) => setErro(erroDe(e, "Não foi possível carregar suas despesas.")))
  }, [])
  useEffect(() => { carregar() }, [carregar, versao])
  const apagar = async (url: string, o: string) => {
    if (!window.confirm(`Apagar este lançamento? (${o})`)) return
    try { await axios.delete(`${API}${url}`); setErro(null); carregar() } catch (e: any) { setErro(erroDe(e, "Não foi possível apagar.")) }
  }
  const etiqueta = (s: string) => <span style={{ color: (STATUS[s] || { cor: "#94a3b8" }).cor, fontSize: 12 }}>{(STATUS[s] || { rotulo: s }).rotulo}</span>
  return (
    <div style={caixa}>
      {erro && <div role="alert" style={{ color: "#f87171", fontSize: 13, marginBottom: 10 }}>{erro}</div>}
      <h4 style={{ marginBottom: 8 }}>⛽ Abastecimentos que eu lancei</h4>
      {abast === null ? <div style={{ color: "#64748b" }}>Carregando...</div> : abast.length === 0 ? <div style={{ color: "#64748b", fontSize: 13 }}>Nenhum ainda.</div> : (
        <table style={{ width: "100%", fontSize: 13, marginBottom: 16 }}><tbody>
          {abast.map((a) => (
            <tr key={a.id} style={{ borderTop: "1px solid #1e2d45" }}>
              <td style={{ padding: "6px 4px" }}>{fmtData(a.data_recibo)}</td><td>{a.ativo_nome}{a.ativo_placa ? ` — ${a.ativo_placa}` : ""}</td><td>{a.motorista_nome || "—"}</td>
              <td>{Number(a.litros).toLocaleString("pt-BR")} L</td><td>{fmtDinheiro(a.valor_total)}</td><td>{etiqueta(a.status)}</td>
              <td>{["pendente_revisao", "anomalia"].includes(a.status) && <button className="btn btn-ghost" style={{ padding: "2px 8px" }} aria-label={`Apagar abastecimento de ${fmtData(a.data_recibo)}`} onClick={() => apagar(`/lancamentos/abastecimentos/${a.id}`, fmtDinheiro(a.valor_total))}>🗑️</button>}</td>
            </tr>
          ))}
        </tbody></table>
      )}
      <h4 style={{ marginBottom: 8 }}>🧳 Despesas de viagem que eu lancei</h4>
      {desp === null ? <div style={{ color: "#64748b" }}>Carregando...</div> : desp.length === 0 ? <div style={{ color: "#64748b", fontSize: 13 }}>Nenhuma ainda.</div> : (
        <table style={{ width: "100%", fontSize: 13 }}><tbody>
          {desp.map((d) => (
            <tr key={d.id} style={{ borderTop: "1px solid #1e2d45" }}>
              <td style={{ padding: "6px 4px" }}>{fmtData(d.data_despesa)}</td><td>{d.viagem_titulo}</td><td>{(CATEGORIAS[d.categoria] || { icone: "📎", rotulo: d.categoria }).icone} {(CATEGORIAS[d.categoria] || { rotulo: d.categoria }).rotulo}</td>
              <td>{fmtDinheiro(d.valor)}</td><td>{etiqueta(d.status)}</td>
              <td>{d.status === "pendente" && <button className="btn btn-ghost" style={{ padding: "2px 8px" }} aria-label={`Apagar despesa de ${fmtData(d.data_despesa)}`} onClick={() => apagar(`/despesas-viagem/${d.id}`, fmtDinheiro(d.valor))}>🗑️</button>}</td>
            </tr>
          ))}
        </tbody></table>
      )}
    </div>
  )
}
